import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes/routes';
import { AuthProvider } from './hooks/useAuth';
import GlobalStyle from './styles/global';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <Routes />
      <GlobalStyle />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
